var stickyFrise = {
  init: function (element) {
    this.$element = element

    this.inView = false
    this.scrollY = window.scrollY

    this.bindUI()
    this.bindEvents()
    this.resize()
  },

  bindUI: function () {
    this.$wrapper = this.$element.querySelector('.js-frise-wrapper')
    this.$content = this.$element.querySelector('.js-frise-content')
    this.$btPrev = this.$element.querySelector('.js-frise-prev')
    this.$btNext = this.$element.querySelector('.js-frise-next')
  },

  bindEvents: function () {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.inView = true
          } else {
            this.inView = false
          }
        })
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0%',
      },
    )
    observer.observe(this.$element)

    window.addEventListener('resize', () => {
      this.resize()
    })

    let ticking = false
    document.addEventListener('scroll', (event) => {
      this.scrollY = window.scrollY

      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.update()
          ticking = false
        })

        ticking = true
      }
    })



    this.$btNext.addEventListener('click', () => {
      const end = this.top + 1.94 * window.innerHeight
      const gap = Math.max(200, Math.min(1410, window.innerWidth) / 4)
      document.documentElement.scrollTop = Math.min(end, document.documentElement.scrollTop + gap)
    })
    this.$btPrev.addEventListener('click', () => {
      const gap = Math.max(200, Math.min(1410, window.innerWidth) / 4)
      document.documentElement.scrollTop = Math.max(this.top, document.documentElement.scrollTop - gap)
    })
  },

  update: function () {
    if (this.inView) {
      const diff = this.bottom - this.top
      const normScroll = Math.max(
        0,
        Math.min(1, (this.scrollY - this.top) / diff),
      )
      this.$content.style.transform = `translate3d(${
        -normScroll * this.width
      }px, 0, 0)`
    }
  },

  resize: function () {
    this.innerWidth = document.documentElement.clientWidth
    this.innerHeight = window.innerHeight

    const boundsFrise = this.$element.getBoundingClientRect()
    const boundsWrapper = this.$wrapper.getBoundingClientRect()
    const boundsContent = this.$content.getBoundingClientRect()

    this.top = boundsFrise.top + this.scrollY + window.innerHeight * 0.06
    this.bottom = boundsFrise.bottom + this.scrollY - this.innerHeight - window.innerHeight * 0.06
    this.width = boundsContent.width - boundsWrapper.width
  },
}

module.exports = stickyFrise
